package app.bloomey.web.core.res

val Res.Strings.fontFamily: String
    get() = "roboto,system-ui"